import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    products: [],
    product: null,
    links: null,
    meta: null,
    filter: {
      keyword: null,
      status: null,
      mainStatus: null,
      buId: null,
      buIds: [],
      categoryIds: [],
      subCategoryIds: [],
    },
    tagTypeOptions: [{ value: 'feature', text: 'Feature Product' }],
    productTagOptions: [
      { value: 'new', text: 'New' },
      { value: 'soon', text: 'Coming Soon' },
    ],
    overWriteFirstHeadLine: 0,
    overWriteSecondHeadLine: 0,
    overWriteThirdHeadLine: 0,
    overWriteFourHeadLine: 0,
    overWriteFivetHeadLine: 0,
  },

  mutations: {
    CLEAR_ALL(state) {
      state.filter = {
        keyword: null,
        status: null,
        mainStatus: null,
        buId: null,
        buIds: [],
        categoryIds: [],
        subCategoryIds: [],
      };
      state.products = [];
      state.product = null;
    },
    SET_PRODUCTS(state, data) {
      state.products = data.data.map((item) => {
        item.isChecked = false;
        return item;
      });
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_PRODUCT(state, data) {
      state.product = data;
      state.product.overWriteFirstHeadLine = state.overWriteFirstHeadLine;
      state.product.overWriteSecondHeadLine = state.overWriteSecondHeadLine;
      state.product.overWriteThirdHeadLine = state.overWriteThirdHeadLine;
      state.product.overWriteFourHeadLine = state.overWriteFourHeadLine;
      state.product.overWriteFivetHeadLine = state.overWriteFivetHeadLine;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setProduct({ commit }, data) {
      commit('SET_PRODUCT', data);
    },

    find({ commit, state }) {
      let url = `/products?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('Product'));
          return response.body;
        })
        .then((response) => {
          commit('SET_PRODUCTS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/products/${id}`)
        .then((response) => response.body)
        .then(typeAs('Product'))
        .then((item) => {
          commit('SET_PRODUCT', item);
        });
    },

    destroy(_, id) {
      return http(`/products/${id}`, { method: 'DELETE' }).then(
        (response) => response.body,
      );
    },

    save(_, { id, ...data }) {
      const request = id
        ? http(`/products/${id}`, { method: 'PUT', data })
        : http('/products', { method: 'POST', data });

      return request.then((response) => response.body);
    },

    publish(_, data) {
      const request = http('/products/publish', { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    mainPublish(_, data) {
      const request = http('/products/main_publish', { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    detachFilterOptions(_, { id, ...data }) {
      const request = http(`/products/${id}/detach_filter_options`, {
        method: 'PUT',
        data,
      });

      return request.then((response) => response.body);
    },

    getProductOptions() {
      return http('/products/options').then((response) => response.body);
    },

    allByBu(_, id) {
      return http(`/bus/${id}/products`).then((response) => response.body);
    },

    allByCategory(_, id) {
      return http(`/product_categories/${id}/products`).then(
        (response) => response.body,
      );
    },

    allBySubCateogry(_, id) {
      return http(`/product_subcategories/${id}/products`).then(
        (response) => response.body,
      );
    },
  },
};
